import React, { useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';
import { motion } from 'framer-motion';
import { Loader2 } from 'lucide-react';
import api from '../services/api';

const PaymentSuccess = () => {
  const [searchParams] = useSearchParams();

  useEffect(() => {
    const reference = searchParams.get('tx_ref') || searchParams.get('transaction_id') || searchParams.get('trxref') || searchParams.get('paymentReference');

    if (reference) {
      api.get(`/payments/verify/${reference}`).catch(() => {});
    }

    const timer = setTimeout(() => window.close(), 1500);
    return () => clearTimeout(timer);
  }, [searchParams]);

  return (
    <div className="min-h-screen flex items-center justify-center px-4 bg-gray-950">
      <motion.div
        initial={{ opacity: 0, scale: 0.8 }}
        animate={{ opacity: 1, scale: 1 }}
        transition={{ type: 'spring', stiffness: 200, damping: 20 }}
        className="bg-gray-900/50 border border-gray-800/60 rounded-2xl max-w-md w-full text-center p-8"
      >
        <motion.div
          animate={{ rotate: 360 }}
          transition={{ duration: 1, repeat: Infinity, ease: 'linear' }}
          className="w-20 h-20 bg-blue-500/20 rounded-full flex items-center justify-center mx-auto mb-6"
        >
          <Loader2 className="text-blue-400" size={40} />
        </motion.div>
        <h1 className="text-2xl font-bold text-white mb-2">Verifying Payment...</h1>
        <p className="text-gray-400">This tab will close automatically.</p>
      </motion.div>
    </div>
  );
};

export default PaymentSuccess;
